// Diccionario español → inglés, dividido por área. Una misma clave no debe tener
// traducciones distintas en dos archivos (lo verifica scripts/i18n-check.mjs).
import core from './core';
import people from './people';
import services from './services';
import checkins from './checkins';
import giving from './giving';
import community from './community';
import member from './member';

export const EN: Record<string, string> = { ...core, ...people, ...services, ...checkins, ...giving, ...community, ...member };
